export default {"src":"/_next/static/media/icon_close.e8fd926b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};